export const profileHelpers = {
  displayName: user => user.name || '@' + user.username,
  avatarImage: user => user.avatar_image || '/static/img/default-avatar.jpg',
  heroImage: user => user.hero_image || '/static/img/default-hero.jpg'
}

export const songHelpers = {
  getThumbnail (song) {
    return song.video_thumbnail || '/static/img/wireframe.svg'
  },
  formatDuration (song) {
    if (!song.duration) return '-'
    let sec = song.duration % 60
    let min = Math.floor(song.duration / 60) % 60
    let hrs = Math.floor(song.duration / 3600) % 60

    if (sec < 10) sec = '0' + sec
    if (min < 10 && hrs > 0) min = '0' + min

    let txt = min + ':' + sec
    if (hrs > 0) txt = hrs + ':' + txt
    return txt
  }
}

export const mapProfileHelpers = (memberName) => {
  const res = {}
  Object.keys(profileHelpers).forEach(key => {
    res[key] = function () {
      return profileHelpers[key](this[memberName])
    }
  })
  return res
}

export function parseErrors (errors) {
  let err = {}
  for (let k in errors) {
    const v = errors[k]
    if (typeof v === 'string') {
      err[k] = v
    } else {
      if (!v.length) continue
      err[k] = v[0]
    }
  }
  return err
}

export function mapErrorStates (fields) {
  let getters = {}
  for (let field of fields) {
    let stateGetter = ('state_' + field).replace(/(_[a-z])/g, (m, p) => p[1].toUpperCase())
    let errorGetter = ('error_' + field).replace(/(_[a-z])/g, (m, p) => p[1].toUpperCase())
    getters[stateGetter] = function () {
      return this.errors[field] ? 'invalid' : null
    }
    getters[errorGetter] = function () {
      return this.errors[field]
    }
  }
  return getters
}



// WEBPACK FOOTER //
// ./src/store/helpers.js